import { render, staticRenderFns } from "./Keepcard.vue?vue&type=template&id=1823fb52&scoped=true&"
import script from "./Keepcard.vue?vue&type=script&lang=js&"
export * from "./Keepcard.vue?vue&type=script&lang=js&"
import style0 from "./Keepcard.vue?vue&type=style&index=0&id=1823fb52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823fb52",
  null
  
)

export default component.exports